import { MaskLines, Reveal } from "../components/anim";
import ParallaxImage from "../components/ParallaxImage";
import { Eyebrow, CTAButton } from "../components/ui-bits";
import { IMG } from "../data/site";
import useSEO from "../hooks/useSEO";

export default function Concept() {
  useSEO(
    "Il concept — Non è il solito bar, è il tuo angolo aperitivo | Sprizziamoci",
    "Sprizziamoci trasforma l'aperitivo in una parte speciale dell'evento: postazione beverage professionale in self service, attrezzature dedicate e servizio organizzato."
  );
  return (
    <article data-testid="concept-page">
      <section className="pt-32 md:pt-44 pb-14">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <Eyebrow>Il concept</Eyebrow>
          <MaskLines
            lines={["NON È IL SOLITO BAR.", "È IL TUO ANGOLO APERITIVO."]}
            as="h1"
            when="load"
            delay={0.15}
            lineClass="font-display font-semibold tracking-tight leading-[1] text-[clamp(2.6rem,6.5vw,5.5rem)]"
            className="mt-6"
          />
        </div>
      </section>

      <Reveal>
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <ParallaxImage
            src={IMG.gazebo}
            alt="L'allestimento Sprizziamoci in funzione: gazebo nero e arancione, banconi self service e ospiti che brindano"
            speed={0.1}
            className="relative h-[46vh] md:h-[64vh] rounded-3xl"
          />
        </div>
      </Reveal>

      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="text-base md:text-lg leading-relaxed text-white/70">
                Portiamo una postazione beverage professionale dove c'è voglia di festeggiare:
                pratica, scenografica, personalizzabile.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-10 rounded-3xl border border-brand-orange/30 bg-brand-orange/[0.05] p-8 md:p-10">
                <p className="eyebrow mb-4">La nostra firma</p>
                <p className="font-display text-2xl md:text-3xl leading-snug">
                  Self service: i tuoi ospiti si servono da soli. Noi portiamo spina, ghiaccio e
                  bicchieri.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid gap-12 lg:grid-cols-12 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="eyebrow mb-5">Aperitivo street food</p>
              <MaskLines
                lines={["L'APERITIVO", "VIAGGIA."]}
                when="view"
                lineClass="font-display font-semibold tracking-tight leading-[1] text-[clamp(2.2rem,4.5vw,3.8rem)]"
              />
              <p className="mt-6 text-base md:text-lg leading-relaxed text-white/65">
                Il nostro mezzo operativo porta il banco e gli erogatori direttamente dove si tiene la festa.
              </p>
              <div className="mt-6 flex flex-wrap gap-2.5">
                {["Self service", "Alla spina", "On the road"].map((c) => (
                  <span
                    key={c}
                    className="rounded-full border border-white/15 px-4 py-2 text-xs text-white/65"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="overflow-hidden rounded-3xl border border-white/[0.07] group">
                <img
                  src={IMG.truck}
                  alt="Il mezzo operativo Sprizziamoci: il food truck dell'aperitivo on the road"
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  data-testid="truck-image"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="mx-auto max-w-7xl px-5 md:px-8 grid gap-10 md:grid-cols-2">
          <Reveal>
            <ParallaxImage
              src={IMG.dimBar}
              alt="Erogatori alla spina per cocktail pre-mix, birre e analcolici"
              speed={0.12}
              className="relative h-[320px] md:h-[440px] rounded-3xl"
            />
          </Reveal>
          <Reveal delay={0.1}>
            <ParallaxImage
              src={IMG.limeIce}
              alt="Ghiaccio e agrumi freschi in preparazione"
              speed={0.12}
              className="relative h-[320px] md:h-[440px] rounded-3xl"
            />
          </Reveal>
        </div>
        <div className="mx-auto max-w-7xl px-5 md:px-8 mt-20">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 rounded-3xl border border-white/[0.08] bg-brand-surface/40 p-10 md:p-14">
              <p className="font-display text-3xl md:text-5xl font-semibold leading-tight max-w-xl">
                Portaci la tua idea. <span className="italic text-brand-orange">Al brindisi pensiamo insieme.</span>
              </p>
              <CTAButton to="/contatti" testId="concept-cta">
                Organizza il tuo evento
              </CTAButton>
            </div>
          </Reveal>
        </div>
      </section>
    </article>
  );
}
